/**
 * Centralized, Swappable Minimalist Light Design Tokens.
 * Modify these tokens when final designer mockups/Figma specs are delivered.
 */
export const themeTokens = {
  colors: {
    bgApp: 'bg-slate-50',
    bgCard: 'bg-white',
    bgHeader: 'bg-white/95 backdrop-blur-md',
    border: 'border-slate-200',
    borderHover: 'hover:border-slate-300',

    // Text hierarchy
    textPrimary: 'text-slate-900',
    textSecondary: 'text-slate-700',
    textMuted: 'text-slate-500',

    // Primary Accents (Cobalt Blue per DESIGN.md)
    brand: {
      primary: 'bg-blue-700 hover:bg-blue-800 text-white shadow-xs',
      soft: 'bg-blue-50 text-blue-900 border-blue-200',
      ring: 'focus:ring-blue-600',
    },

    // Urgency Badges (Editorial Clinical Pills)
    urgency: {
      critical: 'bg-rose-50 text-rose-800 border-rose-200 font-semibold',
      high: 'bg-amber-50 text-amber-900 border-amber-200 font-semibold',
      medium: 'bg-sky-50 text-sky-900 border-sky-200 font-medium',
      low: 'bg-emerald-50 text-emerald-900 border-emerald-200 font-medium',
      unclassified: 'bg-slate-100 text-slate-700 border-slate-200 font-medium',
    },

    // Triage Badges
    triage: {
      requires_action: 'bg-rose-50 text-rose-800 border-rose-200 font-medium',
      monitoring: 'bg-amber-50 text-amber-900 border-amber-200 font-medium',
      closed: 'bg-slate-100 text-slate-700 border-slate-200 font-medium',
    },

    // Agency Badges
    agency: {
      FDA: 'bg-blue-50 text-blue-900 border-blue-200',
      'FDA Enforcement': 'bg-blue-50 text-blue-900 border-blue-200',
      FDA_RECALLS: 'bg-rose-50 text-rose-900 border-rose-200',
      'FDA Recalls': 'bg-rose-50 text-rose-900 border-rose-200',
      FDA_MAUDE: 'bg-amber-50 text-amber-900 border-amber-200',
      'FDA MAUDE': 'bg-amber-50 text-amber-900 border-amber-200',

      'FDA CDRH': 'bg-blue-50 text-blue-900 border-blue-200',
      DEFAULT: 'bg-slate-100 text-slate-800 border-slate-200',
    },
  },

  agencies: [
    { key: 'FDA', label: 'FDA Enforcement' },
    { key: 'FDA_RECALLS', label: 'FDA Recalls' },
    { key: 'FDA_MAUDE', label: 'FDA MAUDE' },
  ],
};
